import React from "react";
import { useGoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { Button, Image } from "@chakra-ui/react";
import GoogleIcon from "../Images/Google-icon.svg";
import { a } from "./appColors";

const googleButtonStyle = {
  display: "flex",
  height: "auto",
  padding: "10px 24px",
  justifyContent: "center",
  alignItems: "center",
  alignSelf: "stretch",
  borderRadius: "14px",
  background: a.surface,
  color: a.text,
  border: "1px solid",
  borderColor: a.border,
  fontFamily: "Mona Sans",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "1",
  whiteSpace: "nowrap",
  boxShadow: "0px 0px 5.9px 0px rgba(0, 0, 0, 0.09)",
  width: "100%",
  cursor: "pointer",
  transition: "background 0.3s, color 0.3s",
  _hover: {
    background: a.hover,
  },
};

// `onError` is what callers pass; `onFailure` is kept for any older caller.
const GoogleLoginButton = ({ onSuccess, onError, onFailure, label = "Sign in with Google", canStart }) => {
  const login = useGoogleLogin({
    onSuccess: (response) => {
      onSuccess(response);
    },
    onError: () => {
      (onError || onFailure)?.();
    },
    flow: "auth-code", // Use authorization code flow
    scope: "openid profile email", // Request necessary scopes
  });
  
  return (
    <Button
      sx={googleButtonStyle}
      // `canStart` may stop the popup opening (say, until terms are agreed).
      onClick={() => (!canStart || canStart()) && login()}
      leftIcon={<Image src={GoogleIcon} alt="" boxSize="20px" />}
      iconSpacing="8px"
    >
      {label}
    </Button>
  );
};

export default GoogleLoginButton;
